var instanceId = 0;
export function reset() {
    instanceId = 0;
}
export function generate() {
    var id = instanceId;
    instanceId += 1;
    return id;
}
